module.exports = __webpack_public_path__ + "static/media/image_1.be24c883.jpg";